"use strict";
/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./subscriptions.js"), exports);
tslib_1.__exportStar(require("./tenants.js"), exports);
tslib_1.__exportStar(require("./subscriptionOperations.js"), exports);
tslib_1.__exportStar(require("./operations.js"), exports);
tslib_1.__exportStar(require("./alias.js"), exports);
tslib_1.__exportStar(require("./subscriptionPolicy.js"), exports);
tslib_1.__exportStar(require("./billingAccount.js"), exports);
//# sourceMappingURL=index.js.map